import { useEffect, useState } from "react";
import Header from "../../Components/UI/Header.tsx";
import { HStack, VCenter, VStack } from "../../../../shared/src/Components/Stacks.ts";
import styled from "styled-components";
import { Button } from "../../../../shared/src/Components/Button.tsx";
import { TbPencil } from "react-icons/tb";
import ExpandableText from "../../Components/UI/ExpandableText.tsx";
import InlineButton from "../../../../shared/src/Components/InlineButton.tsx";
import { useNavigate, useParams } from "react-router";
import { useRootStore } from "../../Store/RootStore.ts";
import { Service } from "../../../../shared/src/Types/Types.ts";
import { toJS } from "mobx";
import { truncate_text } from "../../../../shared/src/Functions/Utils.ts";
import {
    AvatarContainer,
    AvatarIMG,
    BackgroundIMG,
    HeaderContainer,
} from "../../../../shared/src/Components/Service.ts";
import { BiggieSmall, Title } from "../../../../shared/src/Components/Typography.ts";
import { ArrowUpRightFromSquare } from "@gravity-ui/icons";

export const BackgroundFiller = styled.div`
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
    height: 115px;
    width: 100%;
    background-color: var(--disabled);
`;
type PatternProps = {
    img: string;
};

export const BackgroundPattern = styled.div<PatternProps>`
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
    background-repeat: repeat;
    background-image: url(${(props) => props.img});
    width: 100%;
    height: 115px;
`;

export const AvatarFiller = styled.div`
    border-radius: var(--border-radius);
    display: flex;
    flex: 1;
    height: 75px;
    width: 75px;
    border: calc(var(--border-width) * 2) solid var(--border);
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 0.85rem;
`;

const TableRow = styled.tr`
    //&:nth-child(even) {
    //  background-color: #f2f2f2;
    //}
`;

const TableHeader = styled.th`
    text-align: start;
`;

const TableData = styled.td`
    width: 0.1%;
    white-space: nowrap;
`;

function ServicePage() {
    const navigate = useNavigate();
    const store = useRootStore();
    const { id } = useParams();

    const [service, setService] = useState<Service | null>(null);
    useEffect(() => {
        console.log(id);
        if (id === undefined) {
            console.error("No service with id ${id}");
            throw new Error(`No service with id ${id}`);
        }
        const service = store.WalletStore.subscryptoServices.find((service) => service.address.toString() === id);
        if (service) {
            setService(service);
            console.log("service");
            console.log(toJS(service));
        }
    }, [store.WalletStore.subscryptoServices, id]);

    const [backgroundImageError, setBackgroundImageError] = useState(false);

    function handleBackgroundError() {
        setBackgroundImageError(true);
    }

    return (
        <>
            {service && (
                <>
                    <Header title={service.title} icon={<TbPencil size={20} />} />

                    <HeaderContainer>
                        {backgroundImageError || !service.backgroundLink ? (
                            <BackgroundFiller />
                        ) : (
                            <BackgroundIMG src={service.backgroundLink} onError={handleBackgroundError} />
                        )}
                        <AvatarContainer>
                            {!service.logoLink ? (
                                <VCenter>
                                    <h1>?</h1>
                                </VCenter>
                            ) : (
                                <AvatarIMG src={service.logoLink} alt={"avatar"} />
                            )}
                        </AvatarContainer>
                    </HeaderContainer>

                    <HStack gap={"0"}>
                        <VCenter>
                            <p>Subscribers</p>
                            {/*<Title>{TESTDATA.subscribers}</Title>*/}
                            <Title>-</Title>
                            <InlineButton
                                underline={true}
                                onClick={() => {
                                    navigate("/subscribers");
                                }}
                            >
                                просмотреть
                            </InlineButton>
                        </VCenter>
                        <VCenter>
                            <p>Revenue</p>
                            {/*<Title>{TESTDATA.revenue_usdt}</Title>*/}
                            <Title>-</Title>
                            <small>last month</small>
                        </VCenter>
                    </HStack>

                    <ExpandableText title={"Описание"} text={service.description} />
                    <VStack gap={"6"}>
                        <HStack gap={"6"}>
                            <p>Тарифы</p>
                            {service.tariffs.length === 0 && (
                                <Button
                                    size={"mini"}
                                    variant={"primary"}
                                    onClick={() => {
                                        if (!service) throw new Error("no service!");
                                        navigate(`/create_tariff/`, {
                                            state: { service_mint: service.address },
                                        });
                                    }}
                                >
                                    Add
                                </Button>
                            )}
                        </HStack>
                        {service.tariffs.length > 0 ? (
                            <Table>
                                <thead>
                                    <TableRow>
                                        <TableHeader>Имя</TableHeader>
                                        <TableHeader>Подписчики</TableHeader>
                                        <TableHeader>Доход/мес</TableHeader>
                                    </TableRow>
                                </thead>
                                <tbody>
                                    {service.tariffs_metadatas.map((tariff, index) => (
                                        // navigate(`/token/${balance.mint_address}`, {state: {balance: balance}});
                                        <TableRow key={index}>
                                            <TableData>
                                                <InlineButton
                                                    underline={true}
                                                    onClick={() => {
                                                        navigate(`/tariff/${tariff.address}`, {
                                                            state: {
                                                                tariff: tariff,
                                                            },
                                                        });
                                                    }}
                                                >
                                                    {truncate_text(tariff.title, 10)}
                                                </InlineButton>
                                            </TableData>
                                            <TableData>0</TableData>
                                            <TableData>-</TableData>
                                        </TableRow>
                                    ))}
                                </tbody>
                            </Table>
                        ) : (
                            <BiggieSmall variant={"disabled"}>У сервиса нет тарифов</BiggieSmall>
                        )}
                    </VStack>

                    <Button
                        icon={<ArrowUpRightFromSquare />}
                        variant={"primary"}
                        onClick={() => {
                            window.open(`http://localhost:8081/service/${service?.address}`);
                        }}
                    >
                        Поделиться
                    </Button>
                </>
            )}
        </>
    );
}

export default ServicePage;
